export default {
    isDevMode: false,
    // endpointUrl: "http://www.tam-arkiv.se/share/proxy/alfresco-noauth",
    endpointUrl: process.env.REACT_APP_REMOTE_ENDPOINT_URL,
    defaultLanguage: 'en'
}


// WEBPACK FOOTER //
// ./src/config/config.js